import React from 'react';
import AdminOverview from './AdminOverview';

/**
 * Composant de tableau de bord d'administration
 * Ce composant a été simplifié pour n'afficher que la vue d'ensemble
 * Le header, la navigation et les routes sont maintenant gérés par AdminLayout
 */
const AdminDashboard = () => {
  return <AdminOverview />;
};

export default AdminDashboard;